export default __webpack_public_path__ + "static/media/pic8.cca7d1dd.jpg";